import { isNonEmptyString, isNumber, isValidEmail } from '../helpers/validation'
// import { isAfter, subDays } from 'date-fns'

export const courseSchema = [
  {
    key: 'title',
    type: 'text',
    validation: isNonEmptyString,
    error: 'Please enter a title'
  },
  { key: 'company', type: 'text' },
  {
    key: 'provider',
    type: 'select',
    options: {
      key: 'providers',
      name: 'name'
    },
    validation: Boolean,
    error: 'Please select a provider'
  },
  {
    key: 'date',
    type: 'date',
    get default() {
      return new Date()
    }
    // validation: val => isAfter(val, subDays(new Date(), 1)),
    // error: 'Date cannot be in the past'
  },
  {
    key: 'comments',
    multiline: true,
    type: 'text'
  },
  {
    key: 'cancelled',
    type: 'boolean',
    default: false,
    disabled: course => Boolean(Object.keys(course.attendees || {}).length)
  }
]

export const providerSchema = [
  {
    key: 'name',
    type: 'text',
    default: '',
    validation: isNonEmptyString,
    error: 'Please enter a name'
  },
  {
    key: 'color',
    type: 'color',
    default: '#fff'
  }
]

export const registrationSchema = [
  {
    key: 'names',
    type: 'split',
    left: {
      key: 'firstName',
      type: 'text',
      default: '',
      validation: isNonEmptyString,
      error: 'Please enter your first name'
    },
    right: {
      key: 'lastName',
      type: 'text',
      default: '',
      validation: isNonEmptyString,
      error: 'Please enter your last name'
    }
  },
  {
    key: 'emailAddress',
    type: 'text',
    default: '',
    validation: text => !isNonEmptyString(text) || isValidEmail(text),
    error: 'Please enter a valid email address'
  },
  {
    key: 'company',
    type: 'text',
    default: '',
    validation: isNonEmptyString,
    error: 'Please enter your company name'
  },
  {
    key: 'signature',
    type: 'signature',
    validation: isNonEmptyString,
    error: 'Please sign in the box'
  }
]

export const pinUnlockSchema = [
  {
    key: 'pin',
    type: 'password',
    default: '',
    validation: pin => isNonEmptyString(pin) && isNumber(pin),
    error: 'Please enter a numeric PIN'
  }
]

export const userSchema = [
  {
    key: 'email',
    type: 'email',
    readOnly: true
  },
  {
    key: 'displayName',
    type: 'text',
    default: ''
  },
  {
    key: 'pin',
    type: 'password',
    default: ''
  }
]



// WEBPACK FOOTER //
// ./src/constants/schemas.js